import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/report/FullIndex.vue';
import Detail from '@rebuild/materials/shared/report/DetailIndex.vue';
import MobOverview from '@rebuild/materials/shared/report/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/report/MobFullIndex.vue';
import MobDetail from '@rebuild/materials/shared/report/MobDetail.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/report/context';

export function useSelfContext() {
	provideCurrentContext({
		isSZ003010: true
	});
}



export const componentMap = {
	overview: Overview,
	full: withProvider(Full, useSelfContext),
	detail: Detail,
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext),
	'mob-detail': MobDetail
}; 